import { UploadFileData } from "../../../../models/attachment/upload-file-data";

export class DismantledSeriesImagesData {
    
    requestDeviceImages: UploadFileData[] = [];
    requestDeviceSerialNumberImages: UploadFileData[] = [];
}